import React from 'react';
import { Card, Accordion, Col, Row } from 'react-bootstrap';
import Icon from '../../Icons';

const AcademicInformation = ({ employee, activeAccordion, activeKey }) => {
  const {
    careers = [],
    languages = [],
    translatedEducationLevel,
    translatedSenceLevel,
    employeeCertificationsAttributes = []
  } = employee;

  const careerNames = careers.map(career => career.label).join(', ');
  const languagesNames = languages.map(language => language.label).join(', ');

  const certifications = [...employeeCertificationsAttributes].sort(
    (a, b) => new Date(a.endDate) - new Date(b.endDate)
  );

  return (
    <Card className="mr-2">
      <Col className={`${activeKey === 'academic-information' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
        <Accordion.Toggle as={Col} eventKey="2" onClick={activeAccordion} className="card-header-title">
          Información Académica
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="2">
        <Card.Body className="personal-data card-body">
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Nivel de Educación:</span>
                <span className={`answer ${!translatedEducationLevel ? 'text-grey' : ''}`}>
                  {translatedEducationLevel || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Nivel Sence:</span>
                <span className={`answer ${!translatedSenceLevel ? 'text-grey' : ''}`}>
                  {translatedSenceLevel || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Profesión u Oficio:</span>
                <span className={`answer ${!careerNames ? 'text-grey' : ''}`}>{careerNames || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Idiomas:</span>
                <span className={`answer ${!languagesNames ? 'text-grey' : ''}`}>{languagesNames || 'No Aplica'}</span>
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Título y Certificaciones:</span>
                <div className="answer">
                  {certifications.length > 0 ? (
                    certifications.map(cert => (
                      <div key={cert.id} className={`mb-1 py-1 ${!cert.certification?.label ? 'text-grey' : ''}`}>
                        {cert.certification?.label || 'No Aplica'}
                      </div>
                    ))
                  ) : (
                    <div className="mb-1 text-grey">No Aplica</div>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Término Certificación:</span>
                <div className="answer">
                  {certifications.length > 0 ? (
                    certifications.map(cert => (
                      <div key={cert.id} className="d-flex align-items-center mb-1">
                        <span className={`mr-2 ${!cert.endDate ? 'text-grey' : ''}`}>
                          {cert.endDate || 'No Aplica'}
                        </span>
                        {cert.certificateInfo?.fileUrl && (
                          <a
                            href={cert.certificateInfo.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            download={cert.certificateInfo.cleanFilename}
                            title={`Descargar: ${cert.certificateInfo.cleanFilename}`}
                            className="download-icon"
                          >
                            <Icon icon="download-2" height="16px" width="16px" />
                          </a>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="mb-1 text-grey">No Aplica</div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default AcademicInformation;
